<div
  class="wxpt-popup"
  *ngIf="visible"
  [ngStyle]="tooltipStyle"
  (click)="$event.stopPropagation()"
  (wheel)="$event.stopPropagation()"
  (mouseleave)="onMouseLeave()"
>
  <!-- Header: coords + close -->
  <div class="wxpt-header">
    <div class="wxpt-title">
      <mat-icon class="wxpt-pin">place</mat-icon>
      <span
        class="wxpt-coords"
        *ngIf="latitude !== null && longitude !== null"
      >
        Lat: {{ latitude | number:'1.2-2' }}, Lng: {{ longitude | number:'1.2-2' }}
      </span>
    </div>
    <button
      type="button"
      class="wxpt-close"
      aria-label="Close point forecast"
      (click)="onClose()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Scrollable body (everything below the fixed header) -->
  <div class="wxpt-body">

  <!-- Selected time -->
  <div class="wxpt-time" *ngIf="timeIso">
    {{ timeIso | date:'d MMM y':'GMT' }} &middot;
    {{ timeIso | date:'HH:mm':'GMT' }} UTC
  </div>

  <!-- Loading state -->
  <div class="wxpt-loading" *ngIf="loading">
    <mat-spinner diameter="16"></mat-spinner>
    <span>Loading&hellip;</span>
  </div>

  <!-- Content (not loading) -->
  <ng-container *ngIf="!loading">

    <!-- Flat list mode (POI): all variables in a single scrollable list -->
    <ng-container *ngIf="flatMode">
      <div class="wxpt-flat-rows">
        <div
          class="wxpt-row"
          *ngFor="let row of allRows; trackBy: trackByKey"
        >
          <span class="wxpt-row-label">{{ row.label }}</span>
          <span class="wxpt-row-value">{{ row.value }}</span>
        </div>
        <div class="wxpt-empty-state" *ngIf="allRows.length === 0">No data</div>
      </div>
    </ng-container>

    <!-- Two-section mode (AOI / WMS): Active Layers + collapsible Other Variables -->
    <ng-container *ngIf="!flatMode">
      <!-- Section 1: Active Layers (always expanded) -->
      <div class="wxpt-section wxpt-section--active">
        <div class="wxpt-section-header">
          <mat-icon class="wxpt-section-icon">layers</mat-icon>
          <span>Active Layers</span>
        </div>
        <div class="wxpt-active-rows" *ngIf="activeRows.length > 0">
          <div
            class="wxpt-active-row"
            *ngFor="let row of activeRows; trackBy: trackByKey"
          >
            <div class="wxpt-active-row-label">
              <span class="wxpt-active-row-label-text">{{ row.label }}</span>
              <span class="wxpt-info" *ngIf="row.description" tabindex="0">
                <mat-icon class="wxpt-info-icon">info_outline</mat-icon>
                <span class="wxpt-info-tip" role="tooltip">{{ row.description }}</span>
              </span>
            </div>
            <div class="wxpt-active-row-value">{{ row.value }}</div>
          </div>
        </div>
        <div class="wxpt-empty-state" *ngIf="activeRows.length === 0">
          No active layers
        </div>
      </div>

      <!-- Section 2: Other Variables (collapsible) -->
      <div class="wxpt-section wxpt-section--other" *ngIf="otherRows.length > 0">
        <button
          type="button"
          class="wxpt-section-toggle"
          (click)="toggleExpanded(); $event.stopPropagation()"
        >
          <div class="wxpt-section-toggle-label">
            <mat-icon class="wxpt-section-icon">tune</mat-icon>
            <span>Other Variables</span>
          </div>
          <mat-icon class="wxpt-toggle-icon" [class.wxpt-toggle-icon--open]="expanded">
            expand_more
          </mat-icon>
        </button>
        <div class="wxpt-other-rows" *ngIf="expanded">
          <div
            class="wxpt-row"
            *ngFor="let row of otherRows; trackBy: trackByKey"
          >
            <span class="wxpt-row-label">{{ row.label }}</span>
            <span class="wxpt-row-value">{{ row.value }}</span>
          </div>
        </div>
      </div>
    </ng-container>

  </ng-container>

  </div><!-- /.wxpt-body -->
</div>
